import React from "react";

export const PageHeader = ({ overline, title, subtitle, action }) => (
  <div className="border-b border-white/10 grid-bg">
    <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 flex flex-wrap items-end justify-between gap-6">
      <div>
        <p className="font-mono-tech text-xs uppercase text-[#00F0FF] mb-3">{overline}</p>
        <h1 className="font-display font-extrabold text-4xl sm:text-5xl">{title}</h1>
        {subtitle && <p className="mt-3 text-[#94A3B8] max-w-2xl">{subtitle}</p>}
      </div>
      {action}
    </div>
  </div>
);

export const Tier = ({ tier }) => {
  if (!tier || tier === "free" || tier === "standard") return null;
  const map = { featured: "FEATURED", premium: "PREMIUM" };
  return (
    <span className="font-mono-tech text-[10px] uppercase px-2 py-0.5 rounded bg-[#00F0FF]/15 text-[#00F0FF] border border-[#00F0FF]/30">
      {map[tier] || tier}
    </span>
  );
};

export const Empty = ({ text }) => (
  <div className="text-center py-24 text-[#94A3B8]" data-testid="empty-state">{text}</div>
);
